import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.replenishmentCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.replenishmentCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.replenishmentCollections.data.replenishmentCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.replenishmentCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
